import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RolesResponse } from "../response/RolesResponse";

interface useRolesProps {
    name: string;
    page: number;
    limit: number;
    search: string;
}

export const useRoles = ({ name, page, limit, search }: useRolesProps) => {
    return useQuery({
        queryKey: [name, page, limit, search],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v4/role', {
                    params: {
                        page: page,
                        limit: limit,
                        search: search,
                        include: "permissions,users"
                    }
                });

                const validationResult = RolesResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Failed to fetch roles");
                }
                return validationResult.data;

            } catch (error) {
                console.error("Failed to fetch roles", error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};